import { Routes, Route } from 'react-router-dom';
import Layout from '../shared/Layout';
import Home from '../views/Home';
import About from '../views/About';
import Services from '../views/Services';
import Contact from '../views/Contact';
import Tips from '../views/Tips';
import Reviews from '../views/Reviews';
import Resources from '../views/Resources';
import Destination from '../views/Destination';
import GalleryList from '../views/GalleryList';
import DealsView from '../views/DealsView';
import ToarPackage from '../views/ToarPackage';
import VisaAssistance from '../views/VisaAssistance';
import ViewVisaAssistance from '../views/ViewVisaAssistance';

export default function RoutesConfig() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tourpackage" element={<ToarPackage />} />
        <Route path="/tips" element={<Tips />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/destination/:id" element={<Destination />} />
        <Route path="/gallery" element={<GalleryList />} />
        <Route path="/deals-view/:id" element={<DealsView />} />
        <Route path="/visa-assistance" element={<VisaAssistance />} />
        <Route path="/view-visa-assistance" element={<ViewVisaAssistance />} />
      </Routes>
    </Layout>
  );
}

